import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useLanguage } from '../context/LanguageContext';

const DisclaimerPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen">
      <Header />
      
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="font-montserrat-bold text-3xl md:text-4xl text-[#0b004c] mb-8 text-center">
            {t('disclaimerTitle')}
          </h1>
          
          <div className="prose prose-lg max-w-none font-montserrat text-[#6a6a6a]">
            <p className="mb-6">
              <strong>{t('lastUpdated')}</strong> {t('january2025')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('disclaimerGeneralTitle')}</h2>
            <p className="mb-4">
              {t('disclaimerGeneralContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('disclaimerAdviceTitle')}</h2>
            <p className="mb-4">
              {t('disclaimerAdviceContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('disclaimerLinksTitle')}</h2>
            <p className="mb-4">
              {t('disclaimerLinksContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('disclaimerLiabilityTitle')}</h2>
            <p className="mb-4">
              {t('disclaimerLiabilityContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('disclaimerPortfolioTitle')}</h2>
            <p className="mb-4">
              {t('disclaimerPortfolioContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('disclaimerAvailabilityTitle')}</h2>
            <p className="mb-4">
              {t('disclaimerAvailabilityContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('disclaimerChangesTitle')}</h2>
            <p className="mb-4">
              {t('disclaimerChangesContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('disclaimerContactTitle')}</h2>
            <p className="mb-4">
              {t('disclaimerContactIntro')}
            </p>
            <p className="mb-4">
              <strong>{t('email')}:</strong> brian@datasignz.nl<br />
              <strong>{t('phone')}:</strong> +597 8545865
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DisclaimerPage;
